import { GET_SIPCONFIG } from './mutation-types'

export default {
  [GET_SIPCONFIG]: (state, sipConfig) => {
    state.sipConfig = sipConfig
  },
}
